import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { PaymentScreen } from "../screens/PaymentScreen";

export const Route = createFileRoute("/prototype/c/$companyId/purchases/payments/$paymentId")({
  component: SupplierPayment,
});

function SupplierPayment() {
  const { companyId, paymentId } = Route.useParams();
  return (
    <PaymentScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      paymentId={paymentId}
    />
  );
}
